<template>
    <div>
        <v-tooltip top>
            <template v-slot:activator="{ on }">

                <v-btn
                        x-small
                        icon
                        color="grey lighten-1"
                        v-on="on"
                        @click.stop="dialog = true"
                >
                    <v-icon style="font-size: 20px;">mdi-pencil</v-icon>
                </v-btn>
            </template>
            <span>Edit</span>
        </v-tooltip>

        <v-dialog width="600px" v-model="dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">Edit Post</span>
                    <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
                </v-card-title>
                <v-card-text>
                    <v-container class="pl-0 pr-0">
                        <v-form ref="form"
                                v-model="valid"
                                validation>
                            <v-layout row>
                                <v-flex xs12>
                                    <v-col cols="12" sm="12" class="area-select">
                                        <v-select
                                                outlined
                                                label="To*"
                                                required
                                                v-model="addresseeSelect"
                                                :items="addresseeList"
                                                item-value="id"
                                                item-text="value"
                                                @change="resetAddresseeData"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" class="area-select" v-if="addresseeSelect === ADDRESS_TO_RESTAURANTS">
                                        <v-autocomplete
                                                outlined
                                                label="Select (a) Restaurant(s)"
                                                required
                                                deletable-chips
                                                multiple
                                                chips
                                                v-model="restaurantsSelected"
                                                :items="restaurantsList"
                                                item-value="id"
                                                item-text="name"
                                                @change="setRestaurantAsAddressee"
                                                :rules="restaurantSelectRules"
                                        ></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="12" class="area-select" v-if="addresseeSelect === ADDRESS_TO_AREAS">
                                        <v-autocomplete
                                                outlined
                                                label="Select (an) Area(s)"
                                                required
                                                deletable-chips
                                                multiple
                                                chips
                                                v-model="areasSelected"
                                                :items="areasList"
                                                item-value="id"
                                                item-text="name"
                                                @change="setAreaAsAddressee"
                                                :rules="areaSelectRules"
                                        ></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="12" class="area-select" v-if="addresseeSelect === ADDRESS_TO_DRIVERS">
                                        <v-autocomplete
                                                outlined
                                                label="Select (a) Driver(s)"
                                                required
                                                deletable-chips
                                                multiple
                                                chips
                                                v-model="driversSelected"
                                                :items="driversList"
                                                item-value="id"
                                                item-text="full_name"
                                                @change="setDriverAsAddressee"
                                                :rules="driverSelectRules"
                                        ></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                        <v-text-field
                                                clear-icon="mdi-close"
                                                clearable
                                                name="Post Title"
                                                label="Post Title*"
                                                outlined
                                                v-model="postTitle"
                                                :rules="postTitleRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <tiptap-vuetify
                                            v-model="postContent"
                                            placeholder="Post Content*"
                                            :extensions="extensions"
                                            @keydown="postContentModifed"
                                        />
                                        <div class="v-messages theme--light error--text" v-if="this.postContentDirty && !isPostContentValid">
                                            Please enter post content
                                        </div>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-file-input
                                                :rules="imgRules"
                                                accept="image/png, image/jpeg, image/jpg, image/bmp"
                                                placeholder="Upload a file"
                                                prepend-icon="mdi-camera"
                                                label="File"
                                                ref="image"
                                                @change="onChangeFileUpload"
                                        ></v-file-input>
                                        <v-img
                                                max-width="500px"
                                                max-height="300px"
                                                v-model="postImg"
                                                v-if="this.postImg !== null"
                                                :src="`${appConfig.app_url}/images/${this.postImg}`"
                                        ></v-img>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-checkbox
                                                v-model="checkbox"
                                                :true-value="IMPORTANT_YES"
                                                :false-value="IMPORTANT_DEFAULT"
                                                :label="`Important`"
                                        ></v-checkbox>
                                    </v-col>
                                </v-flex>
                            </v-layout>

                            <div class="d-flex justify-center">
                                <v-btn
                                        color="primary"
                                        depressed
                                        class="mr-4"
                                        :disabled="!valid || localLoading || !isPostContentValid"
                                        @click="submit"
                                        :loading="localLoading"
                                >
                                    <v-icon left>mdi-check-box-outline</v-icon>
                                    Accept Changes
                                </v-btn>

                                <v-btn
                                        color="warning"
                                        depressed
                                        @click="cancel"
                                        :loading="localLoading"
                                ><v-icon left>mdi-cancel</v-icon>Cancel</v-btn>
                            </div>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {mapGetters} from 'vuex'
    import { TiptapVuetify, Bold, Italic,/* Strike,*/ Underline } from 'tiptap-vuetify'
    import { IMPORTANT_YES, IMPORTANT_DEFAULT } from '../../store/posts';

    const ADDRESS_TO_ALL = 10;
    const ADDRESS_TO_AREAS = 20;
    const ADDRESS_TO_RESTAURANTS = 30;
    const ADDRESS_TO_DRIVERS = 40;

    export default {
        name: "EditPostModal",
        components: { TiptapVuetify },
        props: ['thisPostData', 'editPost'],
        data(){
            return{
                checkbox: IMPORTANT_DEFAULT,
                file: {},
                dialog: false,
                postData: null,
                ADDRESS_TO_ALL: ADDRESS_TO_ALL,
                ADDRESS_TO_AREAS: ADDRESS_TO_AREAS,
                ADDRESS_TO_RESTAURANTS: ADDRESS_TO_RESTAURANTS,
                ADDRESS_TO_DRIVERS: ADDRESS_TO_DRIVERS,
                postTitle: '',
                postContent: '',
                postContentDirty: false,
                addresseeSelect: ADDRESS_TO_ALL,
                addresseeList: [
                    {
                        id: ADDRESS_TO_ALL,
                        value: 'All',
                    }, {
                        id: ADDRESS_TO_AREAS,
                        value: 'Selected Areas',
                    }, {
                        id: ADDRESS_TO_RESTAURANTS,
                        value: 'Selected Restaurants',
                    }, {
                        id: ADDRESS_TO_DRIVERS,
                        value: 'Selected Driver(s)'
                    },
                ],
                areasSelected: [],
                restaurantsSelected: [],
                driversSelected: [],
                id: '',
                creationDate: null,
                // authorId: null,
                addressee: null,
                valid: false,
                localLoading: false,
                postTitleRules: [
                    v => !!v || 'Please enter post title',
                ],
                postContentRules: [
                    v => !!v || 'Please enter post content',
                ],
                restaurantSelectRules: [
                    v => !!v || 'Please select a restaurant',
                ],
                areaSelectRules: [
                    v => !!v || 'Please select an area',
                ],
                driverSelectRules: [
                    v => !!v || 'Please select (a) driver(s)',
                ],
                imgRules: [
                    value => {
                        if (value && value.size > 10000000) {
                            return 'File size should be less than 10 MB!';
                        }
                        return true;
                    }
                ],
                extensions: [
                    Underline,
                    Italic,
                    Bold,
                    // Strike,
                ],
                IMPORTANT_YES: IMPORTANT_YES,
                IMPORTANT_DEFAULT: IMPORTANT_DEFAULT,
            }
        },
        created(){
            this.postData = this.thisPostData;
            this.postTitle = this.postData.postTitle;

            // setup visible area
            this.addresseeSelect = ADDRESS_TO_ALL;
            if (this.postData.for_areas == 10) {
                this.addresseeSelect = ADDRESS_TO_AREAS;
            }

            if (this.postData.for_restaurants == 10) {
                this.addresseeSelect = ADDRESS_TO_RESTAURANTS; // overwrite ADDRESS_TO_AREAS
            }

            if (this.postData.for_drivers == 10) {
                this.addresseeSelect = ADDRESS_TO_DRIVERS; // overwrite ADDRESS_TO_RESTAURANTS
            }

            this.areasSelected = _.map(this.postData.news_feed_areas, p => +p.area_id);
            this.restaurantsSelected = _.map(this.postData.news_feed_restaurants, p => +p.restaurant_id);
            this.driversSelected = _.map(this.postData.news_feed_drivers, p => +p.driver_id);
            this.checkbox = +this.postData.important;
            this.postContent = this.postData.postContent;
            this.id = this.postData.id;
            this.creationDate = this.postData.creationDate;
            // this.authorId = this.postData.authorId;
            this.addressee = this.postData.addressee;
            this.postImg = this.postData.img;

        },
        computed: {
            ...mapGetters([
                'restaurants',
                'areas',
                'drivers',
            ]),
            areasList() {
                return this.areas;
            },
            restaurantsList() {
                return this.restaurants;
            },
            driversList() {
                return this.drivers;
            },
            isPostContentValid() {
                return !!this.postContent && this.postContent != '<p></p>';
            },
        },
        methods: {
            onChangeFileUpload(file){
                this.file = file;
            },
            resetAddresseeData() {
                this.areasSelected = [];
                this.restaurantsSelected = [];
                this.driversSelected = [];
            },
            setAreaAsAddressee(/*name*/) {
                // --
            },
            setRestaurantAsAddressee(/*name*/) {
                // --
            },
            setDriverAsAddressee(/*name*/) {
                // --
            },
            postContentModifed(/*event, view*/) {
                Vue.nextTick(() => {
                    if (this.postContent == '<p></p>') {
                        this.postContent = '';
                    }
                });

                this.postContentDirty = true;
            },
            submit () {
                if (this.$refs.form.validate()) {
                    this.localLoading = true;

                    let formData = new FormData();
                    // if(Object.keys(this.file).length !== 0) {
                        formData.append('file', this.file);
                    // }
                    formData.append('postTitle', this.postTitle);
                    formData.append('postContent', this.postContent);

                    if (!_.isEmpty(this.areasSelected)) {
                        formData.append('areas', JSON.stringify(this.areasSelected));
                    }

                    if (!_.isEmpty(this.restaurantsSelected)) {
                        formData.append('restaurants', JSON.stringify(this.restaurantsSelected));
                    }

                    if (!_.isEmpty(this.driversSelected)) {
                        formData.append('drivers', JSON.stringify(this.driversSelected));
                    }

                    formData.append('id', this.id);
                    formData.append('important', this.checkbox);

                    this.$store.dispatch('editPost', formData)
                        .then((/* data */) => {
                            this.dialog = false;
                        })
                        .finally(() => {
                            this.localLoading = false;
                        })
                }
            },
            cancel(){
                this.dialog = false
                this.postData = this.thisPostData
                this.postTitle = this.postData.postTitle
                this.checkbox = this.postData.important
                this.postContent = this.postData.postContent
                this.postContentDirty = false;

                this.dialog = false;
            },
        }
    }
</script>

<style scoped>

</style>